import React, { useEffect } from "react";
import messaging from "../support/firebase";
import { getToken } from "firebase/messaging";
import { useMutation } from "urql";
import { registerNotificationsMutation } from "../support/mutations";
import { getRefreshToken } from "../support/graphqlApi";

const PushNotificationButton = () => {
  const [, registerNotifications] = useMutation(registerNotificationsMutation);
  useEffect(() => {
    if (messaging)
      Notification.requestPermission()
        .then(() => {
          return getToken(messaging, {
            vapidKey: process.env.VITE_APP_VAPID_KEY,
          });
        })
        .then((token) => {
          registerNotifications({
            input: { refreshToken: getRefreshToken(), id: token },
          });
        })
        .catch((error) => {
          console.error("Error:", error);
        });
  }, [registerNotifications]);
  return <div />;
};

export default PushNotificationButton;
